<h1>Albion Online Repair Cost Calculator</h1>
@if (selectedItem && selectedItem.localizedName) {
  <h2>{{ selectedItem.localizedName }}</h2>
} @else {
  <h2><br /></h2>
}
@if (shopCategories && items && !isLoading) {
  <div class="flex-container-column">
    <div class="form-container">
      <app-item-selector
        class="form-container-inline"
        [shopCategories]="shopCategories"
        [items]="items"
        [showItemSelector]="true"
        [(selectedCategory)]="selectedCategory"
        [(selectedSubCategory)]="selectedSubCategory"
        [(selectedTier)]="selectedTier"
        [(selectedItem)]="selectedItem"
        >
      </app-item-selector>
      <mat-form-field class="form-item-small">
        <mat-label>Item Damage %</mat-label>
        <input matInput [(ngModel)]="damage" type="number" step="5" min="0" max="100" />
      </mat-form-field>
    </div>
    <br />
    @if (this.selectedItem && this.itemValue) {
      <div>
        <p>
          {{ this.selectedItem.localizedName }} costs <span class="loss-color">{{ this.repairPerDamage | number : '1.2-2' }}</span> per damage % to repair.
        </p>
        @if (damage != 5) {
          <p>
            For 5% damage the total cost is <span class="loss-color" style="font-weight: bold">{{ this.repairPerDamage * 5 | number : '1.0-0' }}</span
            >.
          </p>
        }
        @if (this.damage) {
          <div>
            <p>
              For {{ this.damage / 100 | percent : '1.0-0' }} damage the total cost is
              <span class="loss-color" style="font-weight: bold">{{ this.repairTotal | number : '1.0-0' }}</span
                >.
              </p>
            </div>
          }
        </div>
      }
    </div>
  } @else {
    <mat-spinner></mat-spinner>
  }
